<template>
    <el-container id="container">
        <el-header class="joyce-header">
            <div>
                <p class="joyce-title">
                    Welcome
                </p>
                <p id="link">
                    <a href="#">Contact</a>
                    <a href="#">Blog</a>
                </p>
            </div>
        </el-header>
        <el-container id="body">
            <el-main style="display: flex; flex-direction: row; align-items: center;">
                <div style="width: 1000px; display: flex; align-items: center; margin: auto;
                            justify-content: space-between; color: white;">
                    <div style="width: 530px;"></div>
                    <el-card style="width: 400px;" id="card">
                        <el-form ref="form" :model="form" label-width="80px" label-position="top" :rules="rules">
                            <el-form-item label="企业名" prop="enterprise">
                                <el-input v-model="form.enterprise" placeholder="请输入企业名"></el-input>
                            </el-form-item>
                            <el-form-item label="用户名" prop="username">
                                <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" prop="password">
                                <el-input v-model="form.password" placeholder="请输入密码" show-password></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="login" :loading="submitting" autofocus style="width: 100%;">
                                    登录
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
    import loginService from "../service/loginService";
    import {Message} from "element-ui";

    export default {
        data: function () {
            return {
                form: {
                    username: 'zzz',
                    password: 'zzzzzz',
                    enterprise: 'zz'
                },
                rules: {
                    enterprise: [
                        {required: true, message: '请输入企业名', trigger: 'blur'}
                    ],
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 6, max: 64, message: '长度在 6 到 64 个字符', trigger: 'blur'}
                    ]
                },
                submitting: false
            }
        },
        methods: {
            login: async function () {
                this.$refs['form'].validate(async (valid) => {
                    if (!valid) {
                        return false;
                    }
                    this.submitting = true;
                    let resp = await loginService.login(this.form.enterprise ,this.form.username, this.form.password);
                    if (resp.data.Status === '1'){
                        Message.success('登录成功');
                        this.$router.push('/app/contract/remindConfig');
                    }

                });
            }
        }
    };
</script>
<style scoped>
    #container {
        height: 100%;
    }

    #body {
        background-image: url("../assets/bg.jpg");
        background-size: cover;
    }

    #card {
        background: rgba(255, 255, 255, 0.9);
    }

    #link {
        color: #999;
    }

    #link > a {
        text-underline: none;
        text-decoration-line: none;
        color: inherit;
        padding-left: 30px;
    }

    #link > a:hover {
        color: #606266;
    }

    .joyce-header {
        padding: 0;
        border-bottom: 1px solid #e6e6e6;
    }

    .joyce-header > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
    }

    .joyce-title {
        font-size: 20px;
        display: flex;
        align-items: center;
        margin: 0;
        line-height: 59px;
    }
</style>
